import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=7be957c7&scoped=true&"
import script from "./NoticeMessage.vue?vue&type=script&lang=ts&"
export * from "./NoticeMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeMessage.vue?vue&type=style&index=0&id=7be957c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be957c7",
  null
  
)

export default component.exports